import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import { conversationQueryKeys } from '@/hooks/queries/conversation-query-keys';

const markConversationSeenFn = async (conversationId: string): Promise<void> => {
  await api.post(`/dashboard/conversations/${conversationId}/seen`);
};

export const useMarkConversationSeen = (brandId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: markConversationSeenFn,
    onSuccess: (_, conversationId) => {
      queryClient.invalidateQueries({
        queryKey: conversationQueryKeys.detail(brandId, conversationId),
      });
      queryClient.invalidateQueries({ queryKey: conversationQueryKeys.lists(brandId) });
      queryClient.invalidateQueries({ queryKey: conversationQueryKeys.counters(brandId) });
    },
  });
};
